import React from 'react';

import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { Button } from '@bringg/react-components';
import { Language as LanguageType } from '@bringg/types';

import styles from './tab-title.module.scss';

export interface TabTitleProps {
	language: LanguageType;
	isRemovable: boolean;
	removeButtonAriaLabel?: string;
	['data-test-id']?: string;
	onRemove: () => void;
}

const TabTitle = ({
	language,
	onRemove,
	isRemovable,
	removeButtonAriaLabel = `Remove ${language.name}`,
	'data-test-id': dataTestId
}: TabTitleProps) => (
	<div className={styles.tabTitle}>
		<div>{language.name}</div>
		{isRemovable && (
			<Button
				shape="circle"
				className={styles.removeLanguageBtn}
				aria-label={removeButtonAriaLabel}
				data-test-id={dataTestId}
				icon={<BringgIcon iconName={BringgFontIcons.Close} />}
				onClick={e => {
					e.stopPropagation();
					onRemove();
				}}
			/>
		)}
	</div>
);

export default TabTitle;
